import React, { useState } from "react";

import {
  Box,
  Button,
  FormControlLabel,
  TextField,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  useMediaQuery,
  FormControl,
  FormLabel,
  FormGroup,
  Checkbox,
} from "@material-ui/core";

import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";

import { useInboundContext } from "./context";

export const ExceptionDialog = ({
  saveShipment,
  isExceptionDialogOpen,
  setIsExceptionDialogOpen,
  classes,
}) => {
  const [otherExceptionNoteError, setOtherExceptionError] = useState();
  const { state, dispatch } = useInboundContext();
  const { currentShipment } = state;
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));

  const handleSave = async () => {
    if (!validate()) return;
    if (
      currentShipment.unsafeShipment ||
      currentShipment.brokenSeal ||
      currentShipment.otherException
    ) {
      currentShipment.hasException = true;
      currentShipment.verificationRequired = "true";
    } else {
      currentShipment.hasException = false;
    }
    saveShipment(currentShipment);
    setIsExceptionDialogOpen(false);
  };

  const validate = () => {
    let isValid = true;
    setOtherExceptionError("");
    if (currentShipment.otherException) {
      isValid = isValid && currentShipment.otherExceptionNote;
      !currentShipment.otherExceptionNote &&
        setOtherExceptionError("A note is required for other exceptions");
    }
    return isValid;
  };

  const handleChange = (evt) => {
    const type = evt.target.name;
    const value = evt.target.checked;
    if (type === "unsafeShipment") {
      currentShipment.unsafeShipment = value;
      if (!value) {
        currentShipment.unsafeShipmentNote = "";
      }
    } else if (type === "brokenSeal") {
      currentShipment.brokenSeal = value;
      if (!value) {
        currentShipment.brokenSealNote = "";
      }
    } else {
      currentShipment.otherException = value;
      if (!value) {
        currentShipment.otherExceptionNote = "";
        setOtherExceptionError("");
      }
    }
    dispatch({
      type: "UPDATE_CURRENT_SHIPMENT",
      payload: currentShipment,
    });
  };

  const handleCancel = () => {
    setIsExceptionDialogOpen(false);
  };

  const setNote = (prop, value) => {
    currentShipment[prop] = value;
    dispatch({
      type: "UPDATE_CURRENT_SHIPMENT",
      payload: currentShipment,
    });
  };

  return (
    <Dialog
      open={isExceptionDialogOpen}
      maxWidth={isSmall ? "xl" : "md"}
      fullWidth={true}
    >
      <Box
        component="span"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        m={2}
      >
        <Typography variant="h6">
          {currentShipment.accountName}{" "}
          {isSmall ? (
            <div>{currentShipment.railCarNumber}</div>
          ) : (
            ` - ${currentShipment.railCarNumber}`
          )}
        </Typography>
        <CancelOutlinedIcon fontSize="large" onClick={handleCancel} />
      </Box>
      <DialogContent>
        <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel>Exception Type</FormLabel>
          <FormGroup row={!isSmall}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={currentShipment.unsafeShipment}
                  onChange={handleChange}
                  name="unsafeShipment"
                />
              }
              label="Unsafe Shipment"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={currentShipment.brokenSeal}
                  onChange={handleChange}
                  name="brokenSeal"
                />
              }
              label="Broken seal"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={currentShipment.otherException}
                  onChange={handleChange}
                  name="other"
                />
              }
              label="Other"
            />
          </FormGroup>
        </FormControl>
        {currentShipment.unsafeShipment && (
          <div className={classes.exceptionContainer}>
            <Typography>Unsafe Shipment</Typography>
            <TextField
              name="unSafeNotes"
              label="Notes"
              multiline
              autoFocus
              minRows={3}
              margin="dense"
              variant="outlined"
              fullWidth
              value={
                currentShipment.unsafeShipmentNote
                  ? currentShipment.unsafeShipmentNote
                  : ""
              }
              onChange={(evt) =>
                setNote("unsafeShipmentNote", evt.target.value)
              }
            />
          </div>
        )}
        {currentShipment.brokenSeal && (
          <div className={classes.exceptionContainer}>
            <Typography>Broken Seal</Typography>
            <TextField
              name="brokenNotes"
              label="Notes"
              multiline
              autoFocus
              minRows={3}
              margin="dense"
              variant="outlined"
              fullWidth
              value={
                currentShipment.brokenSealNote
                  ? currentShipment.brokenSealNote
                  : ""
              }
              onChange={(evt) => setNote("brokenSealNote", evt.target.value)}
            />
          </div>
        )}
        {currentShipment.otherException && (
          <div className={classes.exceptionContainer}>
            <Typography>Other</Typography>
            <TextField
              name="otherNotes"
              label="Notes"
              multiline
              autoFocus
              minRows={3}
              error={otherExceptionNoteError}
              helperText={otherExceptionNoteError}
              margin="dense"
              variant="outlined"
              required
              fullWidth
              value={
                currentShipment.otherExceptionNote
                  ? currentShipment.otherExceptionNote
                  : ""
              }
              onChange={(evt) =>
                setNote("otherExceptionNote", evt.target.value)
              }
            />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Box>
          <Box>
            <Button onClick={() => handleCancel()}>Cancel</Button>
            <Button type="submit" onClick={() => handleSave()} color="primary">
              Submit
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
